import { useState, useEffect } from "react";
import { loadAllEmployeeList} from "../services/employeeService";

const useAllEmployeeList = (defaultSelectedID = null) => {
  const [employee, setEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedEmployeeID, setSelectedEmployeeID] = useState(null);
  const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

  const fetchEmployee = async (selectedID = null) => {
    const para = { p_companyid: localStorage.getItem("companyid") };

    try {
      const data = await loadAllEmployeeList(para);
      if (data && data.length > 0) {
        setEmployee(data);

        
        const initial = selectedID
        ? data.find((e) => e.id === selectedID)
        : [];

        if (initial) {
          setSelectedEmployee(initial);
          setSelectedEmployeeID(initial.id);
        }

        setIsEmployeeDataLoaded(true);
      }
    } catch (error) {
      console.error("Failed to load employee list:", error);
    }
  };

  useEffect(() => {
    if (!isEmployeeDataLoaded) {
      fetchEmployee(defaultSelectedID);
    }
  }, [defaultSelectedID, isEmployeeDataLoaded]);

  const loadEmployeeByID = async (selectedID) => {
    await fetchEmployee(selectedID);
  };

  return {
    employee,
    selectedEmployee,
    selectedEmployeeID,
    setSelectedEmployee,
    setSelectedEmployeeID,
    loadEmployeeByID,
  };
};

export default useAllEmployeeList;